<template>
  <section class="container">
    <layout-breadcrumb :items="breadcrumbs"></layout-breadcrumb>
    <div class="row">
      <div class="col-md-12 mb-3">
        <h2 class="font-weight-800 text-transparencia">
          <!-- <a @click="$router.go(-1)"><i class="fa fa-arrow-left cr-po mr-5" data-toggle="tooltip" data-placement="top" title="Volver"></i></a> -->
          {{ datos.titulo || 'VOLUNTARIADO - DETALLE' }}
        </h2>
      </div>
    </div>
    <div class="row justify-content-center border-bottom">
      <div class="col-md-12">
        <div class="mt-3">
          <img :src="`${filesUrl + datos.rutaImagen}`" data-provide="lightbox" class="w-100 cr-po image-round-all" v-if="datos.rutaImagen" />
        </div>
        <p class="mb-5 mt-3 text-justify text-transparencia" v-html="datos.contenido"></p>
      </div>
    </div>
  </section>
</template>

<script>
import layoutBreadcrumb from "@/layout/layout-breadcrumb";

export default {
  name: "view-voluntariado-detalle",
  metaInfo: {
    title: "Voluntariado - Detalle",
  },
  data: () => ({
    datos: {},
  }),
  components: { 
    layoutBreadcrumb
  },
  methods: {
    fetchDatos: async function() {
      const actividadId = this.$route.params.id;
      await this.$http.get(this.apiRoute("Common", "GetVoluntariadoActividadById"), {
        params: { Id: actividadId }
      }).then(function(response) {
        if (!response.body.error) {
          this.datos = response.body.data;
        }
      });
    },
  },
  mounted: async function() {
    await this.fetchDatos();

    this.breadcrumbs = [
      { name: "Inicio", url: "/home", icon: "fa fa-home", active: false },
      { name: "Voluntariado", url: "/voluntariado", icon: "", active: false },
      { name: "Actividades", url: "/voluntariado/actividades", icon: "", active: false },
      { name: "Detalle", url: "", icon: "", active: true },
    ];
  },
};
</script>